import { TAlert, TIncident } from '@core/modules/mdr/cases'
import { NoteItem } from '@ui/drawer/common/noteItem'
import { InfoItem } from '../../../../common/infoItem'
import {
    Content,
    TabContent,
    NotesContent,
    NoInputText,
    Flex,
} from './caseTabCommunication.styles'
import Markdown from 'react-markdown'
import { NOT_AVAILABLE } from '@/ui/components/cases-table/CasesTable.utils'
import { useCustomTheme } from '@atbay/theming'
import AssetDeviceIcon from '@/assets/images/asset-device-icon.svg?react'

interface Props {
    caseData: TAlert | TIncident
}

const isAlert = (data: TAlert | TIncident): data is TAlert => {
    return data.caseType === 'Alert'
}

const CaseTabDetection = ({ caseData }: Props) => {
    const theme = useCustomTheme()

    return (
        <TabContent data-testid="detection-content">
            <Content className="text">
                <InfoItem title="Disposition" dataTestId={`case-disposition`}>
                    {caseData.disposition ? (
                        caseData.disposition
                    ) : (
                        <NoInputText variant="s-regular">
                            {NOT_AVAILABLE}
                        </NoInputText>
                    )}
                </InfoItem>
                <InfoItem
                    title="Affected Host"
                    dataTestId={`case-affected-host`}
                >
                    {caseData.affectedHost ? (
                        <Flex>
                            <AssetDeviceIcon />
                            {caseData.affectedHost}
                        </Flex>
                    ) : (
                        <NoInputText variant="s-regular">
                            {NOT_AVAILABLE}
                        </NoInputText>
                    )}
                </InfoItem>
                <InfoItem
                    title="Associated Users"
                    dataTestId={`case-associated-users`}
                >
                    {caseData.affectedUsers ? (
                        caseData.affectedUsers
                    ) : (
                        <NoInputText variant="s-regular">
                            {NOT_AVAILABLE}
                        </NoInputText>
                    )}
                </InfoItem>
            </Content>

            <Content className="text">
                <InfoItem
                    title="Remediation Action"
                    dataTestId={`case-remediation-action`}
                >
                    {caseData.remediationAction &&
                    caseData.remediationAction.length > 0 ? (
                        caseData.remediationAction.map((action) => (
                            <div key={action}>{action}</div>
                        ))
                    ) : (
                        <NoInputText variant="s-regular">
                            {NOT_AVAILABLE}
                        </NoInputText>
                    )}
                </InfoItem>
                <InfoItem
                    title="Containment"
                    dataTestId={`case-network-containment`}
                >
                    {caseData.networkContainment}
                </InfoItem>
                <InfoItem
                    title="Source Product"
                    dataTestId={`case-source-product`}
                >
                    {isAlert(caseData) && caseData.caseSource ? (
                        caseData.caseSource
                    ) : (
                        <NoInputText variant="s-regular">
                            {NOT_AVAILABLE}
                        </NoInputText>
                    )}
                </InfoItem>
            </Content>
            <NotesContent>
                <NoteItem
                    title="Investigation Notes"
                    testId={`case-investigation-notes`}
                >
                    {caseData.investigationNotes ? (
                        <Markdown>{caseData.investigationNotes}</Markdown>
                    ) : (
                        <NoInputText variant="s-regular">
                            {NOT_AVAILABLE}
                        </NoInputText>
                    )}
                </NoteItem>
                <NoteItem
                    title="Remediation Action Notes"
                    testId={`case-remediation-action-notes`}
                >
                    {caseData.remediationNotes ? (
                        <Markdown>{caseData.remediationNotes}</Markdown>
                    ) : (
                        <NoInputText variant="s-regular">
                            {NOT_AVAILABLE}
                        </NoInputText>
                    )}
                </NoteItem>
            </NotesContent>
        </TabContent>
    )
}

export default CaseTabDetection
